import { render } from "./addInformation.vue?vue&type=template&id=20fe5268&scoped=true"
import script from "./addInformation.vue?vue&type=script&lang=js"
export * from "./addInformation.vue?vue&type=script&lang=js"

import "./addInformation.vue?vue&type=style&index=0&id=20fe5268&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fe5268"]])

export default __exports__